import React, { useEffect, useState } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { BiPlayCircle, BiImage, BiPurchaseTag } from 'react-icons/bi'

import Demo from './pages/Demo'
import Advertising from './pages/Demo/Advertising'
import Prices from './pages/Demo/Prices'
import Page from './pages/templates/Page'
import ShowcaseLayout from './pages/Showcase/ShowcaseLayout'
import ConfiguratorPage from './pages/Showcase/ConfiguratorPage'
import EnvironmentShowcasePage from './pages/Showcase/EnvironmentShowcasePage'
import VideoPage from './pages/VideoPage'
import PageSwitcher from './components/PageSwitcher'
import { Backdrop } from './components/Toaster'
import api from './lib/api'
import EmblaCarousel from './emblaCarousel/EmblaCarousel'

require('./lib/polyfills')

export const routes = [
	{
		path: '',
		title: 'Intro',
		element: <Page Component={Demo} title='Intro' />,
		Icon: BiPlayCircle, // BiInfoCircle
	},
	{
		path: 'displays',
		title: 'Digital Displays',
		element: <Page Component={Advertising} title='Digital Displays' />,
		Icon: BiImage,
	},
	{
		path: 'prices',
		title: 'Digital Prices',
		element: <Page Component={Prices} title='Digital Prices' />,
		Icon: BiPurchaseTag,
	},
	// {
	// 	path: 'dashboard',
	// 	title: 'Dashboard',
	// 	element: <Page Component={Dashboard} title='Dashboard' />,
	// 	Icon: BiBarChart,
	// },
]

const NamaCarouselExperience = () => {
	const [showToastBackdrop, setShowToastBackdrop] = useState(false)

	useEffect(() => {
		api.registerDevice()
	}, [])

	return (
		<>
			<EmblaCarousel setShowToastBackdrop={setShowToastBackdrop} />
			{showToastBackdrop && <Backdrop />}
		</>
	)
}

const App = () => (
	<BrowserRouter>
		<PageSwitcher />
		<Routes>
			<Route path="/showcase" element={<ShowcaseLayout />}>
				<Route index element={<ConfiguratorPage />} />
				<Route
					path="environments"
					element={<EnvironmentShowcasePage />}
				/>
			</Route>
			<Route path="/video" element={<VideoPage />} />
			<Route path="*" element={<NamaCarouselExperience />} />
		</Routes>
	</BrowserRouter>
)

export default App
